/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Annotations_Tab_RulesInputs */



/**
* | output |
* | --- |
* | "Rules" |
*
* @param {Annotations_Tab_RulesInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const annotations_tab_rules = /** @type {((inputs?: Annotations_Tab_RulesInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Annotations_Tab_RulesInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Правила")
	return /** @type {LocalizedString} */ ("Rules")
});